import { render, staticRenderFns } from "./RecAlert.vue?vue&type=template&id=3767380d"
import script from "./RecAlert.vue?vue&type=script&lang=js"
export * from "./RecAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports